<template>
    <div class="element el-operations-reference" :class="{ 'can-change': is_editable }">
        <el-table :class="{ data_table: is_editable }" :table="table_operations_reference" :key="renderKey" condensed />
    </div>
</template>

<script>
// import XLSX from "xlsx";
import { mapGetters } from "vuex";

import excel_mapping from "@/components/study/editor/config/operations_reference.mapping_col_names.json";

import ElTable from "@/components/study/editor/elements/el-table";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

import $ from "jquery";
import _ from "lodash";

const WEIGHTS = {
	T1: { xlo_coef: 1.3, surface: 30, part: 0.2 },
	T2: { xlo_coef: 1.15, surface: 42, part: 0.2 },
	T3: { xlo_coef: 1.0, surface: 62, part: 0.4 },
	T4: { xlo_coef: 0.9, surface: 82, part: 0.15 },
	T5: { xlo_coef: 0.82, surface: 110, part: 0.05 },
};
const TVA_PLEINE = 1.2;
const TVA_AIDE = 1.055;
const stats_typo = {
	surface: 0,
	nb: 0,
	part: 0,
	nb_libre: 0,
	nb_aide: 0,
	total_PUM_libre: 0,
	total_PUM_aide: 0,
	mean_PUM_libre: 0,
	mean_PUM_aide: 0,
};

export default {
	name: "el-operations-reference",
	mixins: [ElementMixin],
	props: {
		upload: {default: false},
	},
	data () {
		return {
			renderKey: 0,
			obs_checked: true,
			progress: 0,
		};
	},
	computed: {
		...mapGetters(["active_study"]),
		table_operations_reference: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [9, 20, 23, 24, 24],
				},
			};
			table.head.push(["", "Surf. hab", "Part", "Prix unitaire hors stat.", "Prix unitaire avec stat."]);

			if (this.hide_aide_column_checked) {
				table.config.cols_width = [12, 18, 18, 26, 26];
				table.head = [["", "Surf. hab", "Part", "Prix unitaire hors stat.", "Prix unitaire avec stat."]];
			}
            
			if(this.parent_data) {
				this.parent_data.forEach((data) => {
					table.body.push([
						data.typologie.toUpperCase(),
						{ parent_data: data, property: "surface", suffix: "m²", format: "number", editable: true, text_align: "center" },
						{ parent_data: data, property: "repartition", suffix: "%", format: "number", editable: true, text_align: "center" },
						{ parent_data: data, property: "prix_tva_pleine_sans_parking", suffix: "€", format: "number", editable: true, text_align: "center" },
						{ parent_data: data, property: "prix_tva_pleine_avec_parking", suffix: "€", format: "number", editable: true, text_align: "center" },
						// { parent_data: {prix_tva_pleine_avec_parking: data.prix_tva_pleine_avec_parking}, property: "prix_unitaire", suffix: "€", format: "number", editable: false }
					]);
				});
			}

			/* for (var type in this.active_study.etudeData.promotion.operations_reference.obs) {
                // let base = "active_study.etudeData.promotion.operations_reference.obs[" + type + "].";
				const ref = this.active_study.etudeData.promotion.operations_reference.obs[type];
				if (this.hide_aide_column_checked) {
					table.body.push([
						type.toUpperCase(),
						{ parent_data: ref, property: "surface", editable: false },
						{ parent_data: ref, property: "part", editable: false },
						{ parent_data: ref, property: "mean_PUM_libre", suffix: "€", format: "number", editable: false },
					]);
				} else {
					table.body.push([
						type.toUpperCase(),
						{ parent_data: ref, property: "surface", editable: false },
						{ parent_data: ref, property: "part", editable: false },
						{ parent_data: ref, property: "mean_PUM_libre", suffix: "€", format: "number", editable: false },
						{ parent_data: ref, property: "mean_PUM_aide", suffix: "€", format: "number", editable: false },
					]);
				}
            } */

			return table;
		},
		table_operations_reference_non_obs: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [50, 20, 30],
				},
			};

			table.head.push(["Operation", "nb lgt", "prix pkg inclus"]);
			for (const op_index in this.active_study.etudeData.promotion.operations_reference.non_obs) {
				// const base = "active_study.etudeData.promotion.operations_reference.non_obs[" + op_index + "].";
				const ref = this.active_study.etudeData.promotion.operations_reference.non_obs[op_index];
				table.body.push([
					ref["name"],
					{ parent_data: ref, property: "nb_lgt", editable: true },
					{ parent_data: ref, property: "price", editable: true, suffix: "€/m²" },
				]);
			}
			return table;
		},
		hide_aide_column_checked: {
			get () {
				return this.active_study.etudeData.promotion.operations_reference.hide_aide_column;
			},
			set (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.promotion.operations_reference,
					field: "hide_aide_column",
					value: value,
				});
			},
		},
	},
	methods: {
		progress_then_update () {
			const self = this;
			this.progress = 1;
			setTimeout(function () {
				self.progress = 0;
				self.update_non_obs_stats();
			}, 2500);
		},
		update_non_obs_stats () {
			const TOTAL_PUM_TVA_PLEINE = { T1: 0, T2: 0, T3: 0, T4: 0, T5: 0 };
			const TOTAL_NB_LGT = { T1: 0, T2: 0, T3: 0, T4: 0, T5: 0 };

			// for each line with a legit nb_lgt and a legit price, add it to ref_ops
			const ref_ops = [];
			for (const op of this.active_study.etudeData.promotion.operations_reference.non_obs) {
				if (op && op.nb_lgt && op.price) {
					ref_ops.push(op);
				}
			}
			const stats = create_stat_container();
			for (const typo in TOTAL_PUM_TVA_PLEINE) {
				const weights = WEIGHTS[typo];
				for (const op of ref_ops) {
					TOTAL_PUM_TVA_PLEINE[typo] +=
                        op.price * weights.xlo_coef * weights.surface * op.nb_lgt * weights.part;

					TOTAL_NB_LGT[typo] += op.nb_lgt * weights.part;
				}
				stats[typo].part = Math.round(100 * weights.part);
				stats[typo].surface = weights.surface;
				stats[typo].mean_PUM_libre = Math.round(TOTAL_PUM_TVA_PLEINE[typo] / TOTAL_NB_LGT[typo]);
				stats[typo].mean_PUM_aide = Math.round((stats[typo].mean_PUM_libre / TVA_PLEINE) * TVA_AIDE);
			}
			this.save_and_display(stats);
		},
		switch_obs () {
			this.obs_checked = !this.obs_checked;
		},
		show_upload_box: function () {
			$(this.$refs.upload_box).click();
		},
		upload_file: function () {
			const input = this.$refs.upload_box;
			if (input.files && input.files[0]) {
				const reader = new FileReader();
				reader.onload = this.process_operations_reference_xls;
				reader.readAsArrayBuffer(input.files[0]);
			}
		},
		process_operations_reference_xls: function (event) {
			setTimeout(() => {
				const stats = compute_stats_operations_reference(event);
				this.save_and_display(stats);
			}, 500);
		},
		save_and_display (stats) {
			// COMMIT the stats_operations_reference to the active study
			// console.log('save_and_display', stats);
			this.edit_study(stats);
			// force re-rendering of the el-table component
			this.renderKey += 1;
			this.$store.dispatch("set_mode", { mode: "viewing" });
		},
	},
	components: {
		ElTable,
	},
};

function create_stat_container () {
	const stats_operations_reference = {};
	for (const typo in excel_mapping.libre) {
		stats_operations_reference[typo] = _.cloneDeep(stats_typo);
		stats_operations_reference[typo].surface = WEIGHTS[typo].surface;
	}
	return stats_operations_reference;
}


function compute_stats_operations_reference (e) {
	// console.log('inside compute_stats_operations_reference');
	const data = new Uint8Array(e.target.result);
	const workbook = XLSX.read(data, { type: "array" });
	//const first_sheet_name = workbook.SheetNames[0];
	const excel_data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);


	let nb_total = 0;
	const stats_operations_reference = create_stat_container();

	// array of imported operations
	//let operations_reference = [];
	// for each row (but not the header one)
	for (const row of excel_data) {
		for (const typo in excel_mapping.libre) {
			const col_ventes_libre = excel_mapping.libre[typo].ventes;
			const col_pum_libre = excel_mapping.libre[typo].PUM;
			const ventes_libre = parseInt(row[col_ventes_libre]);
			const PUM_libre = parseInt(row[col_pum_libre]);
			stats_operations_reference[typo].nb_libre += ventes_libre;
			stats_operations_reference[typo].nb += ventes_libre;
			nb_total += ventes_libre;
			stats_operations_reference[typo].total_PUM_libre += ventes_libre * PUM_libre;


			const col_ventes_aide = excel_mapping.aide[typo].ventes;
			const col_pum_aide = excel_mapping.aide[typo].PUM;
			const ventes_aide = parseInt(row[col_ventes_aide]);
			const PUM_aide = parseInt(row[col_pum_aide]);
			stats_operations_reference[typo].nb_aide += ventes_aide;
			stats_operations_reference[typo].nb += ventes_aide;
			nb_total += ventes_aide;
			stats_operations_reference[typo].total_PUM_aide += ventes_aide * PUM_aide;
		}
	}
	// compute meanPUMLibre
	for (const typo in excel_mapping.libre) {
		stats_operations_reference[typo].mean_PUM_libre = Math.round(
			stats_operations_reference[typo].total_PUM_libre / stats_operations_reference[typo].nb_libre
		);
		stats_operations_reference[typo].mean_PUM_aide = Math.round(
			stats_operations_reference[typo].total_PUM_aide / stats_operations_reference[typo].nb_aide
		);
		stats_operations_reference[typo].part = Math.round((stats_operations_reference[typo].nb / nb_total) * 100);
	}
	// console.log('stats_operations_reference', stats_operations_reference);
	return stats_operations_reference;
}

</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.aide_column_config
	input
		left 0px

.el-image
	.data_table
		display block
		width 100%
		height 112px
		overflow hidden
		background-size cover
		background-color #eee
	.form-upload
		position absolute
		left 0
		top -40px
		right 0
		bottom 0
		background-color alpha(white, 85%)
		border 2px dashed purple
		height 160px

		.non-obs-box
			// background-color white
			color lighten(purple, 15%)
			position absolute
			left 0
			top 40px
			right 0
			bottom 0
			display flex
			align-items center
			justify-content center
			flex-direction column
			.non-obs-table
				width 100%
			.update-stats
				display block
				margin-top 4px
				background-color lighten(purple, 15%)
				color lighten(purple, 85%)
				padding: 4px 8px

		.dropbox
			position absolute
			left 0
			top 40px
			right 0
			bottom 0
			// background-color alpha(purple, 55%)
			display flex
			align-items center
			justify-content center
			cursor pointer
			&:hover
				border-color purple
				background-color alpha(purple, 25%)
				&:before
					background-color purple
			&:before
				content "Glisser votre fichier excel ici"
				text-transform uppercase
				font-weight 600
				background-color lighten(purple, 15%)
				color #fff
				padding 8px 12px
		input[type='file']
			position absolute
			top 0
			left 10000px
			opacity 0

    .onoffswitch {
        position: absolute;
		left 33%
		top 16px
		right 0
		bottom 0
		width 130px
        -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
    }
    .onoffswitch-checkbox {
        display: none;
    }
    .onoffswitch-label {
        display: block; overflow: hidden; cursor: pointer;
        border: 2px solid #999999; border-radius: 20px;
    }
    .onoffswitch-inner {
        display: block; width: 200%; margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }
    .onoffswitch-inner:before, .onoffswitch-inner:after {
        display: block; float: left; width: 50%; height: 30px; padding: 0; line-height: 30px;
        font-size: 11px; color: white; font-weight: bold;
        box-sizing: border-box;
    }
    .onoffswitch-inner:before {
        content: "OBSERVE";
        padding-left: 10px;
        background-color: lighten(purple, 15%);
		color: #FFFFFF;
    }
    .onoffswitch-inner:after {
        content: "NON-OBSERVE";
        padding-right: 10px;
        background-color: lighten(purple, 65%);
		color: lighten(purple, 15%);
        text-align: right;
    }
    .onoffswitch-switch {
        display: block; width: 18px; margin: 6px;
        background: #FFFFFF;
        position: absolute; top: 0; bottom: 0;
        right: 96px;
        border: 2px solid #999999; border-radius: 20px;
        transition: all 0.3s ease-in 0s;
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }
</style>
